import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/VideoTextCard.jsx");
